import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {Subject} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class WorkstreamService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  public url(method: string, id: number = undefined, submethod: string = undefined) {
    let url = this.config.api + '/api/' + method;
    if (id) url += '/' + id;
    if (submethod) url += '/' + submethod;
    return url;
  }

  getWorkstreams() {
    return this.http.get<any>(this.url('workstreams'));
  }

  @Load()
  setWorkStreamOrder(order: number[]) {
    return this.http.post<any>(this.url('workstream/order'), order);
  }

  @Load()
  setWorkStreamItemOrder(workStreamItems: any) {
    return this.http.post<any>(this.url('workstream/workstreamitemorder'), workStreamItems);
  }

  getWorkstreamControlItems(workstreamItemId: any) {
    return this.http.get<any>(this.url('workstreamItem', workstreamItemId, 'controlItems'));

  }

  getWorkstreamItem(workstreamItemId: number) {
    return this.http.get<any>(this.url('workstreamItem', workstreamItemId));

  }

  deleteWorkstreamItem(workstreamItemId: number) {
    return this.http.delete<any>(this.url('workstreamItem', workstreamItemId));
  }

  deleteWorkstream(workstreamId: number) {
    return this.http.delete<any>(this.url('workstream', workstreamId));
  }

  saveWorkstreamItem(workstreamItem: any) {
    return this.http.post<any>(this.url('workstreamItem'), workstreamItem);
  }

  saveWorkstream(workstream: any) {
    return this.http.post<any>(this.url('workstream'), workstream);
  }

  duplicateWorkstream(workstreamId) {
    return this.http.put<any>(this.url('workstream', workstreamId, 'duplicate'), {});
  }

  upload(entity: File, name: string) {
    let formData = new FormData();
    formData.append(entity.name, entity, name);

    return this.http.post<any>(this.url('workstream/upload'), formData);
  }

  removeControlItem(workstreamItemId, controlItem: any) {
    return this.http.delete<any>(this.url('workstreamItem', workstreamItemId, 'controlItem/' + controlItem));
  }

  addControlItem(workstreamItemId, controlItem) {
    return this.http.put<any>(this.url('workstreamItem', workstreamItemId, 'controlItem/' + controlItem), {});
  }
}
